import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { placeOrder,fetchOrder,updateOrderStatus } from "../services/placeOrderServices";



export const placeYourOrder = createAsyncThunk(
  "placeorder/placeyourorder",
  async (orderData, { getState, rejectWithValue }) => {
    const { auth } = getState();
    const token = auth.api_token;

    if (!token) {
      console.log("You cannot place an order without logging in!");
      return rejectWithValue("User not logged in");
    }

    try {
      const response = await placeOrder(orderData);
      return response; // Fix: Return the expected array directly
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to place order");
    }
  }
);

export const fetchYourOrder = createAsyncThunk(
  "order/fetchOrder",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchOrder();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateOrder = createAsyncThunk(
  "order/updateOrder",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await updateOrderStatus(id, status); // API call to update order status
      return { id, status }; // Return updated order data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const placeOrderSlice = createSlice({
  name: "placeorder",
  initialState: {
    orderData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(placeYourOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(placeYourOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.orderData = action.payload;
      })
      .addCase(placeYourOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       // Handle fetch addresses
      .addCase(fetchYourOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchYourOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.orderData = action.payload;
      })
      .addCase(fetchYourOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        state.loading = false;
        const { id, status } = action.payload;

        state.orderData = state.orderData.map((order) =>
          order.id === id ? { ...order, status } : order
        );

      })
      .addCase(updateOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default placeOrderSlice.reducer;
